module.exports = __webpack_public_path__ + "img/2.e9e4b792.png";